import { createFileRoute } from '@tanstack/react-router'
import { product } from '@/lib/queries/products'
import { STPPage } from '@/features/workspaces/stp'
import { stpSearchSchema } from '@/features/workspaces/stp/stp-search-schema'

function STPRouteComponent() {
  const { orgId, workspaceId } = Route.useParams()
  return <STPPage orgId={orgId} workspaceId={workspaceId} />
}

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/sketch-to-product/'
)({
  validateSearch: stpSearchSchema,
  // Only preload the filter options used by the grid's filter dropdowns.
  // The products list is fetched by the grid itself — its query key includes
  // the grid's filter object, which is constructed at render time and can't
  // be matched by a route loader without duplicating the filter-building logic.
  loader: async ({ context, params }) => {
    await context.queryClient.query({
      ...product.findFilterOptions(params.workspaceId),
      staleTime: 'static',
    })
  },
  staticData: { layout: 'fluid' },
  component: STPRouteComponent,
})
